import { render, staticRenderFns } from "./summary_business.vue?vue&type=template&id=00ad9454&"
import script from "./summary_business.vue?vue&type=script&lang=ts&"
export * from "./summary_business.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports